<template>
  <div>
    <!-- 关联商品 -->
    <div class="common-form mt50">关联设置</div>
    <el-form-item size="small" label="关联设备">
      <el-button icon="el-icon-plus" @click="changeProduct(form.equipData)">选择关联设备</el-button>
      <div class="pb50">
        <el-table size="small" :data="form.equipData" border>
          <el-table-column label="图片" width="60">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic">
                  <img width="30px" height="30px" v-img-url="scope.row.cover" alt="product_image"/></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="name" label="设备"></el-table-column>
          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="deleteClick(scope.$index)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>
    <!--商品选择-->
    <Equip :is_open="isproduct" :excludeIds="excludeIds" :multi="false" @close="closeDialogFunc"></Equip>

  </div>
</template>

<script>

import {mergeTable} from '@/utils/table.js';
import Equip from '@/components/fs/equip.vue';
export default {
  components: {
    /*选择商品组件*/
    Equip,
  },
  data() {
    return {
      unit: '%',
      isproduct: false,
      /*产品去重*/
      excludeIds: [],
    };
  },
  props: {
    form: Object,
    type: String
  },
  methods: {
    /*关闭弹窗*/
    /*关闭弹窗*/
    closeDialogFunc(e) {
      console.log("e",e)
      let self = this;
      self.isproduct = false;
      if (e.type === 'success') {
        let item = e.params;
          let obj = {
            name: item.name,
            equip_id: item.equip_id,
            cover: item.cover
          };
        self.form.equipData = [obj];
      }
    },
    /*打开添加*/
    changeProduct(list) {
      let arr = [];
      arr = [list.equip_id];
      this.excludeIds = arr;
      this.isproduct = true;
    },
    /*删除商品*/
    deleteClick(e) {
      let curItem = this.form.equipData[e];
      for (let i = 0; i < this.form.equipData.length; i++) {
        let item = this.form.equipData[i];
        if (curItem.equip_id == item.equip_id) {
          if (this.type == 'edit' && e.tempProduct != true) {
            let equip_id = item.equip_id;
            this.form.product_del_ids.push(equip_id);
          }
          this.form.equipData.splice(i, 1);
          i--;
        }
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/product/product/part/RelationEquip.vue